import FormControl from "./FormControl";
import { IValidator } from "./Validators";

export default class FormGroup extends FormControl<any> implements IValidator {
    private _controls : FormControl<any>[]
    private _ids : Record<string,FormControl<any>> = {}

    constructor(name:string, controls:FormControl<any>[]) {
        super(name, [])
        this._controls = controls
        for(const control of controls) this._ids[control.name] = control
        ;(window as any).g = this
    }

    override get valid(){
        for(const control of this._controls) {
            if (!control.valid) return false
        }
        return true
    }

    override update(value:Record<string,any>, silent:boolean=false) {
        let valid = true
        for(const control of this._controls){
            control.update(value[control.name], true)
            valid = valid && control.valid
        }
        this.setValid(valid, silent)
        return this
    }

    control(name:string) { return this._ids[name]}
    override setDirty(dirty:boolean, silent:boolean=false){
        for(const control of this._controls) control.setDirty(dirty, silent)
        return super.setDirty(dirty, silent)
    }

    markAllAsDirty(){
        for(const control of this._controls){
            if(control instanceof FormGroup) control.markAllAsDirty()
            control.setDirty(true)
        }
        return this.setDirty(true)
    }
}